import React from 'react';
import { Calendar, Target, Users } from 'lucide-react';

const CampaignTemplates = ({ campaigns }) => {
  const templates = [
    {
      id: 'concert_promotion',
      name: 'Promotion Concert',
      description: 'Template pour promouvoir un concert ou événement musical',
      icon: Calendar,
      utm_source: 'agent_promo',
      utm_medium: 'social',
      utm_campaign: 'concert_{{date}}'
    },
    {
      id: 'artist_discovery',
      name: 'Découverte Artiste',
      description: 'Template pour faire découvrir un nouvel artiste',
      icon: Users,
      utm_source: 'influencer_share',
      utm_medium: 'qr_code',
      utm_campaign: 'artist_discovery'
    },
    {
      id: 'booking_request',
      name: 'Demande de Booking',
      description: 'Template pour générer des demandes de réservation',
      icon: Target,
      utm_source: 'agent_network',
      utm_medium: 'email',
      utm_campaign: 'booking_outreach'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Templates de Campagne
      </h3>
      <div className="space-y-4">
        {templates?.map((template) => {
          const IconComponent = template?.icon;
          return (
            <div
              key={template?.id}
              className="p-4 border border-gray-200 rounded-lg hover:border-indigo-300 cursor-pointer transition-colors"
            >
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <IconComponent className="h-6 w-6 text-indigo-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-gray-900">
                    {template?.name}
                  </h4>
                  <p className="text-xs text-gray-500 mt-1">
                    {template?.description}
                  </p>
                  <div className="mt-2 space-y-1">
                    <div className="text-xs text-gray-600">
                      <span className="font-medium">Source:</span> {template?.utm_source}
                    </div>
                    <div className="text-xs text-gray-600">
                      <span className="font-medium">Medium:</span> {template?.utm_medium}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {campaigns && campaigns?.length > 0 && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-900 mb-3">
            Campagnes actives
          </h4>
          <div className="space-y-2">
            {campaigns?.slice(0, 3)?.map((campaign) => (
              <div
                key={campaign?.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <div className="text-sm font-medium text-gray-900">
                    {campaign?.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {campaign?.description}
                  </div>
                </div>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  {campaign?.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignTemplates;